import { useRef, useEffect } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useLocalStorage } from 'beautiful-react-hooks';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Pill from '../components/c-pill';

export default function TriggerRecorder() {
	const intRef = useRef(null);
	const [session, setSession] = useLocalStorage('session');
	const h = useHistory();

	useEffect(() => {
		try {
			if (session) {
				const { token, puid, option } = session;
				// intRef.current = setInterval(() => check_state({ token, puid }), 2000);
				const to = option == 1 ? 37 : option == 2 ? 20 : 27;
				intRef.current = setTimeout(() => h.push('/G'), (to + 13) * 1000);
			}
		} catch (error) {
			console.log('error', error);
		}
		return () => clearTimeout(intRef.current);
	}, []);

	const cancel = async (id) => {
		try {
			if (session) {
				const { token, puid, srv } = session;
				const action = 'finish';

				const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
				await axios.post(`${base}/${puid}/act`, { action }, { headers: { Authorization: `Bearer ${token}` } });

				setSession(null);

				h.push('/');
			}
		} catch (error) {
			console.log('error', error);
		}
	};

	return (
		<IonPage>
			<IonContent fullscreen scrollY={true}>
				<div className='w-full h-full justify-items-center items-center flex flex-col bg-c-purple'>
					<img src='/assets/media/gravando.png' className='mt-12 w-[60vw]' />
					<img src='/assets/media/loading.gif' className='mt-12 ' />
					<motion.img src='/assets/media/bt-cancel.png' className='mt-auto mb-12' onTap={cancel} />
				</div>
			</IonContent>
		</IonPage>
	);
}
